import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
import CustomExchangeUserItem from '~/components/Items/CustomExchangeUserItem.vue';
import { IGyriUserItem } from '~/types/user-items';


export default /*#__PURE__*/_defineComponent({
  __name: 'MysteryBoxExchangeDialog',
  props: {
    show: { type: Boolean },
    item: null
  },
  emits: ['closed'],
  setup(__props: any, { emit }) {

const props = __props as {
  show: boolean;
  item: IGyriUserItem;
}




const showDialog = ref(props.show);

const show = computed(() => props.show);

watch(show, (current, previous) => {
  if (current === previous) {
    return;
  }
  showDialog.value = current;
});

function closeDialog() {
  emit('closed');
  showDialog.value = false;
}

return { __sfc: true,emit, props, showDialog, show, closeDialog, CustomExchangeUserItem }
}

})